import styles from './index.module.scss';
import logo from '@assets/images/header/parrot-logo.svg';
import telegramIcon from '@assets/images/vault/telegram.svg';
import xIcon from '@assets/images/vault/x.svg';
import mIcon from '@assets/images/vault/m.svg';
import gitbookIcon from '@assets/images/vault/gitbook.svg';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { globalSettingModel } from '@models/global-setting.model';
import { useModel } from 'foca';

const Footer: FC = () => {
  const theme = useModel(globalSettingModel, (state) => state.theme);

  return (
    <div className={`${styles.footer} ${theme === 'dark' ? styles.dark : ''}`}>
      <div className={styles.left}>
        <img src={logo} />
        <div className={styles.left_text}>
          <div className={styles.p1}>Parrot Finance</div>
          <div className={styles.p2}>One-stop earn aggregator</div>
        </div>
      </div>
      <div className={styles.right}>
        <Link to="">
          <img src={telegramIcon} />
        </Link>
        <Link to="">
          <img src={xIcon} />
        </Link>
        <Link to="">
          <img src={mIcon} />
        </Link>
        <Link to="">
          <img src={gitbookIcon} />
        </Link>
      </div>
      <div className={styles.copyright}>Copyright © 2025 Parrot. All rights reserved</div>
    </div>
  );
};

export default Footer;
